import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IconsModule } from '@features/icons/icons.module';
import { LoadingBarModule } from '@features/shared/loading-bar/loading-bar.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CollectionListItemModule } from './collection-list-item/collection-list-item.module';
import { UserCollectionSelectorComponent } from './user-collection-selector.component';

@NgModule({
  imports: [
    IconsModule,
    CommonModule,
    NgbDropdownModule,
    ReactiveFormsModule,
    CollectionListItemModule,
    LoadingBarModule,
  ],
  declarations: [UserCollectionSelectorComponent],
  exports: [UserCollectionSelectorComponent],
})
export class UserCollectionSelectorModule {}
